// RadicalPresetDialogs.jsx
import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material";

export const RadicalSavePresetDialog = ({
    open,
    onClose,
    presetName,
    onCreate,
    onOverwrite,
    title = "Guardar preset",
    newItemText = "un preset nuevo",
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>
            <Typography variant="body2">
                Puedes actualizar “{presetName || "la receta seleccionada"}” o
                guardar estos cambios como {newItemText}.
            </Typography>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Cancelar</Button>
            <Button onClick={onCreate}>Crear nuevo</Button>
            <Button variant="contained" onClick={onOverwrite}>
                Sobrescribir
            </Button>
        </DialogActions>
    </Dialog>
);

export const RadicalConfirmDialog = ({
    open,
    onClose,
    title,
    description,
    confirmText = "Aceptar",
    confirmColor = "error",
    onConfirm,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>
            <Typography variant="body2">{description}</Typography>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Cancelar</Button>

            <Button
                color={confirmColor}
                variant="contained"
                onClick={onConfirm}
            >
                {confirmText}
            </Button>
        </DialogActions>
    </Dialog>
);

export const RadicalUnsavedChangesDialog = ({
    open,
    onClose,
    currentPresetName,
    nextPresetName,
    message,
    actionText = "Descartar y cambiar",
    onDiscard,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Cambios sin guardar</DialogTitle>

        <DialogContent>
            <Typography variant="body2">
                {message || (
                    <>
                        Has modificado “
                        {currentPresetName || "la receta actual"}”. Al cargar “
                        {nextPresetName || "otra receta"}” se perderán esos
                        cambios.
                    </>
                )}
            </Typography>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Cancelar</Button>

            <Button color="warning" variant="contained" onClick={onDiscard}>
                {actionText}
            </Button>
        </DialogActions>
    </Dialog>
);

export const RadicalRenamePresetDialog = ({
    open,
    onClose,
    value,
    onChange,
    onSave,
    label = "Nombre del preset",
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Editar nombre</DialogTitle>

        <DialogContent>
            <TextField
                autoFocus
                fullWidth
                label={label}
                value={value}
                onChange={onChange}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        onSave();
                    }
                }}
                sx={{ mt: 1 }}
            />
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Cancelar</Button>

            <Button
                variant="contained"
                disabled={!value.trim()}
                onClick={onSave}
            >
                Guardar
            </Button>
        </DialogActions>
    </Dialog>
);
